class Constants {
    static SystemAdminId = "C3B2D618-96FE-4656-8C84-408B44EA2345";
    static boardMemberId = "4ca6b275-cf5b-4547-8e35-88a25e1d9042";
    static UnitId = "3ca8ddc1-c4ae-4435-9bfd-58cb9ecb73ca";
}

export default Constants;